<template>
  <v-sheet :height="this.$root.windowHeight">
    <v-container class="fill-height" >
      <v-row justify="center">
      <v-col align="center" v-if="!details">
        <v-row justify="center" align="center">
          <h1>
            {{ headline }}
          </h1>
        </v-row>
        <v-row align="center" justify="center" class="mt-12">
          <v-col xl="3" lg="4" sm="12" cols="12" v-for="person in people" :key="person.tmdb_id" class="overflow-y-auto">
            <v-avatar size="110" @click="toStarMovies(person)" class="hidden-sm-and-up" >
              <v-img :src="'https://www.themoviedb.org/t/p/w600_and_h900_bestv2' + person.profile"/>
            </v-avatar>
            <v-avatar size="150" @click="toStarMovies(person)" class="hidden-xs-only">
              <v-img :src="'https://www.themoviedb.org/t/p/w600_and_h900_bestv2' + person.profile" class="v-card--link"/>
            </v-avatar>
            <h5 class="mt-3">{{ person.name }}</h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else align="center">
        <v-card max-width="400">
          <v-card-title>
            <v-card-actions>
              <v-btn icon outlined @click="back">
                <v-icon>
                  mdi-keyboard-backspace
                </v-icon>
              </v-btn>
              <v-card-title>
                {{ movies.length }} con {{ selected.name }}
              </v-card-title>
            </v-card-actions>
          </v-card-title>
          <MovieWall :records="movies"/>
        </v-card>
      </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>

import MovieWall from "@/components/MovieWall";
export default {
  name: "TopPeople",
  props: ['headline', 'people'],
  components: {MovieWall},
  data: () => ({
    page: 0,
    details: false,
    movies: [],
    selected: null,
  }),
  methods: {
    toStarMovies(person) {
      this.details = true
      this.movies = person.movies
      this.selected = person
    },
    back() {
      this.details = false
      this.movies = []
      this.selected = null
    }
  }
}
</script>

<style scoped>

</style>
